/* eslint-disable @typescript-eslint/no-explicit-any */

export type IPaymentHelperConfig = object;
export const NOOP_PAYMENT_ADAPTER_CONFIG: IPaymentHelperConfig = {};

export interface TicketOrderIncomeConfig {
  applyProducts: boolean,
  applySupplements: boolean,
}

export interface TicketOrderRefundConfig {
  includeStandardFee: boolean,
  includeProductFee: boolean,
  includeProducts: boolean,
  includeSupplements: boolean,
}

export interface ProductOrderRefundConfig {
  includeStandardFee: boolean,
}

export function isTicketOrderIncomeConfig(config: any): config is TicketOrderIncomeConfig {
  return (
    config !== null &&
    typeof config === 'object' &&
    typeof config.applyProducts === 'boolean' &&
    typeof config.applySupplements === 'boolean'
  );
}

export function isTicketOrderRefundConfig(config: any): config is TicketOrderRefundConfig {
  return (
    config !== null &&
    typeof config === 'object' &&
    typeof config.includeStandardFee === 'boolean' &&
    typeof config.includeProductFee === 'boolean' &&
    typeof config.includeProducts === 'boolean' &&
    typeof config.includeSupplements === 'boolean'
  );
}

export function isProductOrderRefundConfig(config: any): config is ProductOrderRefundConfig {
  return (
    config !== null &&
    typeof config === 'object' &&
    typeof config.includeStandardFee === 'boolean'
  );
}
